document.addEventListener('DOMContentLoaded', () => {
  // Works for any element that has data-modal="#targetID"
  document.querySelectorAll('[data-modal]').forEach(opener => {
    const targetSel = opener.dataset.modal;
    const modal     = document.querySelector(targetSel);
    if (!modal) return;

    const closeBtn  = modal.querySelector('.modal-close');

    const openModal = () => {
      modal.classList.add('is-active');
      document.body.style.overflow = 'hidden';      // stop background scroll
      (modal.querySelector('button, [href], input, select, textarea') || modal)
        .focus();
    };

    const closeModal = () => {
      modal.classList.remove('is-active');
      document.body.style.overflow = '';
      opener.focus();
    };

    opener.addEventListener('click', openModal);
    closeBtn?.addEventListener('click', closeModal);

    modal.addEventListener('click', e => {          // click on overlay
      if (e.target === modal) closeModal();
    });

    document.addEventListener('keydown', e => {     // Esc key
      if (e.key === 'Escape' && modal.classList.contains('is-active'))
        closeModal();
    });
    
  });

  
  const images = document.querySelectorAll('img[data-loading="true"]');

    images.forEach(img => {
      const realSrc = img.getAttribute("data-src");
      const realSrcset = img.getAttribute("data-srcset");
      const realSizes = img.getAttribute("data-sizes");

      const temp = new Image();
      temp.src = realSrc;
      if (realSrcset) temp.srcset = realSrcset;
      if (realSizes) temp.sizes = realSizes;

      temp.onload = function () {
        img.src = realSrc;
        if (realSrcset) img.srcset = realSrcset;
        if (realSizes) img.sizes = realSizes;
        img.setAttribute("data-loading", "false");
      };
    });


      // Get the modal
var modal = document.getElementById("myModaloffer");

// Get the button that opens the modal
var btn = document.getElementById("myBtnoffer");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("closeoffer")[0];

// When the user clicks on the button, open the modal
btn.onclick = function() {
  modal.style.display = "block";
}

// When the user clicks on <span> (x), close the modal
span.onclick = function() {
  modal.style.display = "none";
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
}
});





function enableHoverMenuForDesktop() {
  if (window.innerWidth > 749) {
    document.querySelectorAll('.mega-menu').forEach((menuItem) => {
      const summary = menuItem.querySelector('summary');

      if (summary) {
        summary.addEventListener('mouseenter', () => {
          menuItem.setAttribute('open', true);
        });

        menuItem.addEventListener('mouseleave', () => {
          menuItem.removeAttribute('open');
        });
      }
    });
  }
}

// Run on initial load
enableHoverMenuForDesktop();


//chat button js
(() => {
  const btn = document.getElementById('open-chat');
  if (!btn) return;

  function openInbox() {
    const host = document.querySelector('#ShopifyChat');
    const toggle = host?.shadowRoot?.querySelector('.chat-toggle');

    if (toggle) {
      document.getElementById('shopify-chat')?.classList.add('show'); // unhide bubble
      toggle.click();                         // open chat window
      
        setTimeout(closeInbox, 1000); // Adjust delay if needed
      
      
    } else {
      /* widget not ready yet – try again shortly */
      setTimeout(openInbox, 300);
    }
  }

  function closeBox(){
    document.getElementById('shopify-chat').classList.remove('show');
  }
  
  const closeInbox = () => {
  const host = document.querySelector('inbox-online-store-chat') || document.querySelector('#ShopifyChat');

  if (!host) {
    console.error('Inbox host not found');
    return;
  }

  const tryAttachListener = () => {
    // Try accessing the shadow DOM
    const shadowRoot = host.shadowRoot;
    if (!shadowRoot) {
      console.error('Shadow DOM not ready yet');
      return;
    }

    const closeBtn = shadowRoot.querySelector('.chat-app button[name="closeChat"]');

    if (!closeBtn) {
      console.error('Close / toggle button not found inside shadowRoot');
    } else {
      closeBtn.addEventListener('click', e => {
        e.preventDefault();
        closeBox();
      });
    }
  };

  // Retry logic to wait for shadow DOM to be ready
  const interval = setInterval(() => {
    if (host.shadowRoot) {
      clearInterval(interval);
      tryAttachListener();
    }
  }, 300);
};
  
  btn.addEventListener('click', e => { e.preventDefault(); openInbox(); });
})();

// cart drawer progress bar
function slider_fun(){
    
    let slider = document.querySelector(".slider");
  let items = document.querySelectorAll(".slider-item");
  let dotsContainer = document.querySelector(".slider-dots");

  let index = 0;
  let itemsToShow = 1; // Always show 2 slides per row
  let totalItems = items.length;
  let visibleDots = Math.ceil(totalItems / itemsToShow);
  let startX, currentTranslate = 0, prevTranslate = 0, isDragging = false;

  function updateSlider(smooth = true) {
    let shiftPercentage = (index * 100) / itemsToShow;
    slider.style.transition = smooth ? "transform 0.4s ease-in-out" : "none";
    slider.style.transform = `translateX(-${shiftPercentage}%)`;

    document.querySelectorAll(".dot").forEach((dot, idx) => {
      dot.classList.toggle("active", idx === Math.floor(index / itemsToShow));
    });
  }

  function createDots() {
    dotsContainer.innerHTML = "";
    for (let i = 0; i < visibleDots; i++) {
      let dot = document.createElement("div");
      dot.classList.add("dot");
      if (i === 0) dot.classList.add("active");
      dot.addEventListener("click", function () {
        index = i * itemsToShow;
        updateSlider();
      });
      dotsContainer.appendChild(dot);
    }
  }

  createDots();

  // **Enable Dragging on Desktop & Mobile**
  function touchStart(e) {
    startX = e.touches ? e.touches[0].clientX : e.clientX;
    isDragging = true;
    prevTranslate = index * -100 / itemsToShow;
    slider.style.transition = "none";
  }

  function touchMove(e) {
    if (!isDragging) return;
    let currentX = e.touches ? e.touches[0].clientX : e.clientX;
    let moveX = startX - currentX;
    currentTranslate = prevTranslate - (moveX / window.innerWidth) * 100;
    slider.style.transform = `translateX(${currentTranslate}%)`;
  }

  function touchEnd(e) {
    let endX = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
    let difference = startX - endX;

    if (difference > 100) {
      // Scroll **2 slides at a time**
      if (index < totalItems - itemsToShow) {
        index += 1;
      } else {
        index = 0;
      }
    } else if (difference < -100) {
      if (index > 0) {
        index -= 1;
      } else {
        index = totalItems - itemsToShow;
      }
    }

    isDragging = false;
    updateSlider();
  }

  // **Event Listeners for Dragging**
  slider.addEventListener("mousedown", touchStart, { passive: true });
  slider.addEventListener("mousemove", touchMove, { passive: true });
  slider.addEventListener("mouseup", touchEnd, { passive: true });
  slider.addEventListener("mouseleave", touchEnd, { passive: true });

  slider.addEventListener("touchstart", touchStart, { passive: true });
  slider.addEventListener("touchmove", touchMove, { passive: true });
  slider.addEventListener("touchend", touchEnd, { passive: true });

  window.addEventListener("resize", function () {
    itemsToShow = 1; // Always 2 products per slide
    visibleDots = Math.ceil(totalItems / itemsToShow);
    createDots();
    updateSlider();
  });
}

// Access Shopify variables from global window object
var moneyFormat = window.money_format;

function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }

  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  const defaultTo = (value, defaultValue) => value == null || value !== value ? defaultValue : value;

  const formatWithDelimiters = (number, precision = 2, thousands = ",", decimal = ".") => {
    if (isNaN(number) || number == null) return "0";
    number = (number / 100).toFixed(precision);
    const [intPart, decPart] = number.split(".");
    const formattedInt = intPart.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
    return formattedInt + (decPart ? decimal + decPart : "");
  };

  const placeholder = formatString.match(placeholderRegex)?.[1] || "amount";
  let value = "";

  switch (placeholder) {
    case "amount": value = formatWithDelimiters(cents, 2); break;
    case "amount_no_decimals": value = formatWithDelimiters(cents, 0); break;
    case "amount_with_space_separator": value = formatWithDelimiters(cents, 2, " ", "."); break;
    case "amount_with_comma_separator": value = formatWithDelimiters(cents, 2, ".", ","); break;
    case "amount_with_apostrophe_separator": value = formatWithDelimiters(cents, 2, "'", "."); break;
    case "amount_no_decimals_with_comma_separator": value = formatWithDelimiters(cents, 0, ".", ","); break;
    case "amount_no_decimals_with_space_separator": value = formatWithDelimiters(cents, 0, " "); break;
    case "amount_no_decimals_with_apostrophe_separator": value = formatWithDelimiters(cents, 0, "'"); break;
    default: value = formatWithDelimiters(cents, 2);
  }

  return formatString.replace(placeholderRegex, value);
}

async function getCartDetails() {
  const response = await fetch('/cart.js');
  if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
  return response.json();
}

function confetti_fun() {
  const cartDrawer = document.querySelector(".cart-drawer");
  if (!cartDrawer) return;

  const canvas = document.createElement("canvas");
  Object.assign(canvas.style, {
    position: "absolute", top: 0, left: 0, width: "100%", height: "100%"
  });
  cartDrawer.appendChild(canvas);

  const myConfetti = confetti.create(canvas, { resize: true });
  myConfetti({ particleCount: 1000, spread: 300, origin: { y: 1.0 } });

  setTimeout(() => canvas.remove(), 1500);
}

async function progressbar(data) {
  try {
    if (!data?.item_count) data = await getCartDetails();
    if (!data || typeof data.item_count === "undefined") return;

    const settings = window.progressSettings;
    const els = {
      freePhase: document.getElementById("freeoffphase"),
      firstPhase: document.getElementById("firstoffphase"),
      secondPhase: document.getElementById("secondoffphase"),
      discountBox: document.getElementById("summary_discount"),
      shippingPrice: document.getElementById("shipping_price"),
      discountText: document.getElementById("discounted_amount_txt"),
      mainBody: document.getElementById("body_main"),
      summaryBox: document.getElementById("summary_shipping"),
      textElement: document.querySelector(".pro-text-all"),
      progressBar: document.getElementById("progressbarfilluppp"),
      totalPrice: Number(document.getElementById("total_cart_price")?.dataset.totalPrice) || 0,
      comparePrice: Number(document.getElementById("total_cart_cprice")?.dataset.totalCprice) || 0
    };

    let discountedAmount = 0;
    const oldCount = Number(els.mainBody?.dataset.cartItemCount || 0);
    let progressCount = Number(els.mainBody?.dataset.progressBarCount || 0);
    const currentValue = settings.thresholdType === 'cart_total_based' ? data.original_total_price / 100 : data.item_count;

    const width = Math.min((currentValue / settings.discountThird) * 100, 100);
    if (els.progressBar) els.progressBar.style.width = `${width}%`;

    const checkThreshold = (threshold, countValue) => {
      if (progressCount === countValue - 1 && currentValue > oldCount && currentValue >= threshold) {
        progressCount = countValue;
        els.mainBody.setAttribute("data-progress-bar-count", progressCount);
        confetti_fun();
      }
    };
    checkThreshold(settings.discountFirst, 1);
    checkThreshold(settings.discountSecond, 2);
    checkThreshold(settings.discountThird, 3);
    if (currentValue < oldCount) {
      progressCount = 0;
      els.mainBody.setAttribute("data-progress-bar-count", progressCount);
    }

    const calculatePack = (nextThreshold) => {
      const diff = nextThreshold - currentValue;
      return settings.thresholdType === 'cart_total_based' ? formatMoney(diff * 100) : diff;
    };

    const updateUI = (msg, phaseCount) => {
      els.textElement.innerHTML = msg;
      els.freePhase.classList.toggle("m-active", phaseCount > 0);
      els.firstPhase.classList.toggle("m-active", phaseCount > 1);
      els.secondPhase.classList.toggle("m-active", phaseCount > 2);
      els.discountBox.style.display = phaseCount > 0 ? 'flex' : 'none';
      els.shippingPrice.innerHTML = `<span>FREE</span>`;
      els.summaryBox.style.marginBottom = phaseCount > 0 ? '10px' : '0px';
      els.summaryBox.style.borderBottom = phaseCount > 0 ? '1px dashed #ccc' : 'none';
    };

    if (currentValue < settings.discountFirst) {
      const pack = calculatePack(settings.discountFirst);
      const msg = settings.freeShippingMsg.replace("{item_count}", pack);
      if (els.comparePrice > 0) {
        discountedAmount = els.comparePrice - els.totalPrice;
        const msgFormatted = settings.discountMsg.replace("{discount_price}", formatMoney(discountedAmount));
        els.discountText.innerHTML = msgFormatted;
      }
      updateUI(msg, 0);
    } else if (currentValue < settings.discountSecond) {
      const pack = calculatePack(settings.discountSecond);
      const msg = settings.firstDiscountMsg.replace("{item_count}", pack);
      if (els.comparePrice > 0) discountedAmount = els.comparePrice - els.totalPrice;
      discountedAmount += settings.freeShippingPrice;
      els.discountText.innerHTML = settings.discountMsg.replace("{discount_price}", formatMoney(discountedAmount));
      updateUI(msg, 1);
    } else if (currentValue < settings.discountThird) {
      const pack = calculatePack(settings.discountThird);
      const msg = settings.secondDiscountMsg.replace("{item_count}", pack);
      if (els.comparePrice > 0) discountedAmount = els.comparePrice - els.totalPrice;
      discountedAmount += settings.freeShippingPrice + data.total_discount;
      els.discountText.innerHTML = settings.discountMsg.replace("{discount_price}", formatMoney(discountedAmount));
      updateUI(msg, 2);
    } else {
      els.textElement.innerHTML = settings.thirdDiscountMsg;
      if (els.comparePrice > 0) discountedAmount = els.comparePrice - els.totalPrice;
      discountedAmount += settings.freeShippingPrice + data.total_discount;
      els.discountText.innerHTML = settings.discountMsg.replace("{discount_price}", formatMoney(discountedAmount));
      updateUI(settings.thirdDiscountMsg, 3);
    }

    els.mainBody.setAttribute("data-cart-item-count", currentValue);
    if (typeof slider_fun === "function") slider_fun();

  } catch (e) {
    console.error("progressbar error:", e);
  }
}

document.addEventListener("DOMContentLoaded", async function () {
  const data = await getCartDetails();
  progressbar(data);
});


document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
      var video = document.getElementById("video-{{ card_product.id }}");
      var image = document.getElementById("image-{{ card_product.id }}");
      if (video && image) {
        image.style.display = "none";
        video.style.display = "block";
        video.play();
      }
    }, 12000);
});


document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.product-media-wrapper').forEach(wrapper => {
      const img = wrapper.querySelector('.product-hover-image');
      if (!img) return;
      wrapper.addEventListener('mouseenter', () => img.style.opacity = 1);
      wrapper.addEventListener('mouseleave', () => img.style.opacity = 0);
    });



  
  const addButton = document.getElementById('add-bundle-to-cart');
  if(addButton){
  const originalText = addButton.textContent;

  addButton.addEventListener('click', async function () {
    const variant1 = document.getElementById('variant1').value;
    const variant2 = document.getElementById('variant2').value;

    // Disable button and show loading text
    addButton.disabled = true;
    addButton.textContent = 'Adding...';

    try {
      // Add items to cart
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            { id: parseInt(variant1), quantity: 1 },
            { id: parseInt(variant2), quantity: 1 }
          ]
        })
      });

      // Update cart drawer
      const response = await fetch('/?section_id=cart-drawer');
      const text = await response.text();
      const newDrawerHTML = new DOMParser()
        .parseFromString(text, 'text/html')
        .querySelector('cart-drawer');

      const oldDrawer = document.querySelector('cart-drawer');
      if (oldDrawer && newDrawerHTML) {
        oldDrawer.replaceWith(newDrawerHTML);
        document.body.classList.add('overflow-hidden');
        newDrawerHTML.setAttribute('open', '');
        newDrawerHTML.classList.add('animate', 'active');
      }

      // Update cart bubble
      const cart = await fetch('/cart.js').then(res => res.json());
      const cartBubble = document.querySelector('.cart-count-bubble');
      if (cartBubble) {
        const itemCount = cart.item_count;
        cartBubble.textContent = itemCount;
        cartBubble.classList.toggle('hidden', itemCount === 0);
      }

    } catch (error) {
      console.error('Error adding bundle to cart:', error);
    } finally {
      // Re-enable button and restore original text
      addButton.disabled = false;
      addButton.textContent = originalText;
    }
  });
  }


  document.querySelectorAll('.faq-question').forEach((btn) => {
      btn.addEventListener('click', () => {
        const answer = btn.nextElementSibling;
        const icon = btn.querySelector('.faq-icon');

        btn.classList.toggle('active');
        answer.classList.toggle('open');

        // Toggle icon between "+" and "–"
        icon.textContent = icon.textContent === "+" ? "–" : "+";
      });
  });
});
